import { createTheme } from "@mui/material/styles";
import { blue, red } from "@mui/material/colors";

//NOTE Create Custom Theme
const darkTheme = createTheme({
  direction: "rtl",
  palette: {
    mode: "dark",
    primary: {
      main: "#8be9fd",
    },
    secondary: {
      main: "#bd93f9",
    },
    background: {
      default: "#3F4652",
    },
    reverse: {
      dark: "#ffffff",
      light: "#000000",
      menuItemReverse: "#7fff00",
      status: "dark",
    },
  },
  typography: {
    fontFamily: "vazir, roboto",
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: "dashed" },
          style: {
            textTransform: "none",
            border: `2px dashed ${blue[500]}`,
          },
        },
        {
          props: { variant: "dashed", color: "secondary" },
          style: {
            border: `4px dashed ${red[500]}`,
          },
        },
      ],
    },
  },
});

const lightTheme = createTheme({
  direction: "rtl",
  palette: {
    mode: "light",
    primary: {
      main: "#1565c0",
    },
    secondary: {
      main: "#1976d2",
    },
    background: {
      default: "#42a5f5",
    },
    reverse: {
      dark: "#000000",
      light: "#ffffff",
      menuItemReverse: "#0000ff",
      status: "light",
    },
  },
  typography: {
    fontFamily: "vazir, roboto",
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: "dashed" },
          style: {
            textTransform: "none",
            border: `2px dashed ${blue[500]}`,
          },
        },
        {
          props: { variant: "dashed", color: "secondary" },
          style: {
            border: `4px dashed ${red[500]}`,
          },
        },
      ],
    },
  },
});

export { darkTheme, lightTheme };
